import { useOptionalArtifactDisplay } from '../../context/ArtifactDisplayContext';
import { useMediaQuery } from '../../pages/models/useMediaQuery';
import { useAppSelector } from '../../store/hooks';

/** Matches the desktop grid in layout.css where the timeline gets its own 30% column. */
const DESKTOP_CHAT_COLUMN_QUERY = '(min-width: 1280px)';

/**
 * Whether the project composer should use its compact toolbar. The merged
 * timeline keeps one 30%-wide chat column on desktop whether or not an
 * artifact is open, so the composer stays compact in both states there;
 * narrower viewports only compact for the artifact slide view.
 */
export const useCompactComposer = (projectId: string | null): boolean => {
  const artifactDisplay = useOptionalArtifactDisplay();
  const conversationVisible = useAppSelector((state) => state.planning.activeRightTab === 'ai-overview');
  const desktopColumn = useMediaQuery(DESKTOP_CHAT_COLUMN_QUERY, false);
  const artifactOpen = Boolean(artifactDisplay?.state.isOpen && artifactDisplay.state.activeTab);

  return Boolean(projectId && conversationVisible && (artifactOpen || desktopColumn));
};
